import BillingSection from './billing.component'
import BET_3938 from '../BET_3938'

export default {
  BillingSection,
  useIsFullMonthlySettlementEnabled: BET_3938.useIsFullMonthlySettlementEnabled,
}
